// LINE LIFF Service
// Provider: MFU Wellness (ID: 2004746214)
// Channel ID: 2008976726
// LIFF ID: 2008976726-IQNBGcne
// Bot Link: ON (เชื่อมกับ MFU Wellness Center OA)

const LIFF_ID = '2008976726-IQNBGcne';

// เก็บสถานะ LIFF
let isLiffInitialized = false;
let liffError = null;

/**
 * Initialize LIFF SDK
 * ต้องเรียกก่อนใช้งานฟังก์ชันอื่น
 */
export const initializeLiff = async () => {
  if (isLiffInitialized) {
    console.log('LIFF already initialized');
    return true;
  }

  try {
    // ตรวจสอบว่า liff object มีอยู่หรือไม่
    if (typeof window.liff === 'undefined') {
      throw new Error('LIFF SDK not loaded');
    }

    await window.liff.init({ liffId: LIFF_ID });
    isLiffInitialized = true;
    console.log('LIFF initialized successfully');
    console.log('LIFF isLoggedIn:', window.liff.isLoggedIn());
    console.log('LIFF isInClient:', window.liff.isInClient());

    return true;
  } catch (error) {
    liffError = error;
    console.error('LIFF initialization failed:', error);
    return false;
  }
};

/**
 * ตรวจสอบว่า user login แล้วหรือยัง
 */
export const isLoggedIn = () => {
  if (!isLiffInitialized) {
    console.warn('LIFF not initialized');
    return false;
  }
  return window.liff.isLoggedIn();
};

/**
 * Login ผ่าน LINE
 */
export const loginWithLine = () => {
  if (!isLiffInitialized) {
    console.error('LIFF not initialized');
    return;
  }

  if (!window.liff.isLoggedIn()) {
    window.liff.login();
  }
};

/**
 * Logout จาก LINE
 */
export const logoutFromLine = () => {
  if (!isLiffInitialized) {
    console.error('LIFF not initialized');
    return;
  }

  if (window.liff.isLoggedIn()) {
    window.liff.logout();
    window.location.reload();
  }
};

/**
 * ดึง LINE User ID (userId)
 * ต้อง login ก่อนถึงจะใช้ได้
 */
export const getLineUserId = async () => {
  if (!isLiffInitialized) {
    console.error('LIFF not initialized');
    return null;
  }

  if (!window.liff.isLoggedIn()) {
    console.warn('User not logged in');
    return null;
  }

  try {
    const profile = await window.liff.getProfile();
    console.log('LINE Profile:', profile);
    return profile.userId;
  } catch (error) {
    console.error('Failed to get LINE profile:', error);
    return null;
  }
};

/**
 * ดึง LINE Profile (userId, displayName, pictureUrl, statusMessage)
 */
export const getLineProfile = async () => {
  if (!isLiffInitialized) {
    console.error('LIFF not initialized');
    return null;
  }

  if (!window.liff.isLoggedIn()) {
    console.warn('User not logged in');
    return null;
  }

  try {
    const profile = await window.liff.getProfile();
    console.log('LINE Profile:', profile);
    return profile;
  } catch (error) {
    console.error('Failed to get LINE profile:', error);
    return null;
  }
};

/**
 * ดึง ID Token (JWT)
 * ใช้สำหรับ verify กับ backend
 */
export const getIdToken = () => {
  if (!isLiffInitialized) {
    console.error('LIFF not initialized');
    return null;
  }

  if (!window.liff.isLoggedIn()) {
    console.warn('User not logged in');
    return null;
  }

  try {
    const idToken = window.liff.getIDToken();
    console.log('ID Token:', idToken ? 'obtained' : 'null');
    return idToken;
  } catch (error) {
    console.error('Failed to get ID Token:', error);
    return null;
  }
};

/**
 * ดึง Decoded ID Token (ข้อมูลที่ decode แล้ว)
 */
export const getDecodedIdToken = () => {
  if (!isLiffInitialized) {
    console.error('LIFF not initialized');
    return null;
  }

  if (!window.liff.isLoggedIn()) {
    console.warn('User not logged in');
    return null;
  }

  try {
    const decodedToken = window.liff.getDecodedIDToken();
    console.log('Decoded ID Token:', decodedToken);
    return decodedToken;
  } catch (error) {
    console.error('Failed to get Decoded ID Token:', error);
    return null;
  }
};

/**
 * ตรวจสอบว่าเปิดใน LINE App หรือไม่
 */
export const isInLineClient = () => {
  if (!isLiffInitialized) {
    return false;
  }
  return window.liff.isInClient();
};

/**
 * ดึงข้อมูล LINE ทั้งหมดและบันทึกลง localStorage
 */
export const getAndStoreLineData = async () => {
  if (!isLiffInitialized) {
    console.error('LIFF not initialized');
    return null;
  }

  if (!window.liff.isLoggedIn()) {
    console.log('User not logged in to LINE');
    return null;
  }

  const lineData = {
    lineUserId: null,
    displayName: null,
    pictureUrl: null,
    statusMessage: null,
    idToken: null
  };

  // พยายามดึง profile (ต้องมี scope: profile)
  try {
    const profile = await window.liff.getProfile();
    lineData.lineUserId = profile.userId;
    lineData.displayName = profile.displayName;
    lineData.pictureUrl = profile.pictureUrl || null;
    lineData.statusMessage = profile.statusMessage || null;

    // บันทึกลง localStorage
    localStorage.setItem('lineUserId', profile.userId);
    localStorage.setItem('lineDisplayName', profile.displayName);
    if (profile.pictureUrl) {
      localStorage.setItem('linePictureUrl', profile.pictureUrl);
    }

    console.log('LINE Profile stored:', {
      lineUserId: profile.userId,
      displayName: profile.displayName
    });
  } catch (error) {
    console.warn('Cannot get LINE profile (scope: profile not granted):', error.message);
  }

  // พยายามดึง ID Token (ต้องมี scope: openid)
  try {
    const idToken = window.liff.getIDToken();
    if (idToken) {
      lineData.idToken = idToken;
      localStorage.setItem('lineIdToken', idToken);
      console.log('LINE ID Token stored');
    }
  } catch (error) {
    console.warn('Cannot get ID Token (scope: openid not granted):', error.message);
  }

  // ถ้าไม่ได้ profile แต่ได้ decodedIdToken ให้ลองดึง sub (user id) จาก token
  if (!lineData.lineUserId) {
    try {
      const decodedToken = window.liff.getDecodedIDToken();
      if (decodedToken && decodedToken.sub) {
        lineData.lineUserId = decodedToken.sub;
        localStorage.setItem('lineUserId', decodedToken.sub);
        console.log('LINE User ID from decoded token:', decodedToken.sub);
      }
    } catch (error) {
      console.warn('Cannot get decoded ID Token:', error.message);
    }
  }

  // ถ้าได้ข้อมูลอะไรมาบ้าง ให้ return
  if (lineData.lineUserId || lineData.idToken) {
    return lineData;
  }

  console.warn('No LINE data could be retrieved. Please check LIFF scopes (profile, openid).');
  return null;
};

/**
 * ดึง LINE User ID จาก localStorage
 */
export const getStoredLineUserId = () => {
  return localStorage.getItem('lineUserId');
};

/**
 * ดึง LINE ID Token จาก localStorage
 */
export const getStoredLineIdToken = () => {
  return localStorage.getItem('lineIdToken');
};

/**
 * ลบข้อมูล LINE จาก localStorage
 */
export const clearLineData = () => {
  localStorage.removeItem('lineUserId');
  localStorage.removeItem('lineDisplayName');
  localStorage.removeItem('linePictureUrl');
  localStorage.removeItem('lineIdToken');
};

/**
 * เก็บ auth token แบบ persistent (ใช้ทั้ง localStorage และ sessionStorage)
 */
export const saveAuthToken = (token, userData) => {
  if (token) {
    localStorage.setItem('token', token);
    localStorage.setItem('userToken', token);
    sessionStorage.setItem('token', token);
    sessionStorage.setItem('userToken', token);
    console.log('💾 Token saved to both localStorage and sessionStorage');
  }
  if (userData) {
    const userDataStr = typeof userData === 'string' ? userData : JSON.stringify(userData);
    localStorage.setItem('userData', userDataStr);
    sessionStorage.setItem('userData', userDataStr);
    console.log('💾 User data saved to both localStorage and sessionStorage');
  }
};

/**
 * ดึง auth token (ลอง localStorage ก่อน แล้วค่อย sessionStorage)
 */
export const getAuthToken = () => {
  return localStorage.getItem('token') ||
         localStorage.getItem('userToken') ||
         sessionStorage.getItem('token') ||
         sessionStorage.getItem('userToken');
};

/**
 * ดึง user data (ลอง localStorage ก่อน แล้วค่อย sessionStorage)
 */
export const getUserData = () => {
  const userData = localStorage.getItem('userData') || sessionStorage.getItem('userData');
  if (userData) {
    try {
      return JSON.parse(userData);
    } catch (e) {
      return userData;
    }
  }
  return null;
};

/**
 * ลบ auth token และ user data ทั้งหมด
 */
export const clearAuthData = () => {
  localStorage.removeItem('token');
  localStorage.removeItem('userToken');
  localStorage.removeItem('userData');
  sessionStorage.removeItem('token');
  sessionStorage.removeItem('userToken');
  sessionStorage.removeItem('userData');
  console.log('🗑️ All auth data cleared');
};

export default {
  initializeLiff,
  isLoggedIn,
  loginWithLine,
  logoutFromLine,
  getLineUserId,
  getLineProfile,
  getIdToken,
  getDecodedIdToken,
  isInLineClient,
  getAndStoreLineData,
  getStoredLineUserId,
  getStoredLineIdToken,
  clearLineData,
  saveAuthToken,
  getAuthToken,
  getUserData,
  clearAuthData
};
